var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0023 11.1917C11.4383 11.1917 12.6023 10.0276 12.6023 8.5917C12.6023 7.15576 11.4383 5.9917 10.0023 5.9917C8.5664 5.9917 7.40234 7.15576 7.40234 8.5917C7.40234 10.0276 8.5664 11.1917 10.0023 11.1917Z",
    stroke: "#0082CD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.0148 7.07508C4.65646 -0.141583 15.3481 -0.13325 16.9815 7.08342C17.9398 11.3167 15.3065 14.9001 12.9981 17.1168C11.3231 18.7334 8.67313 18.7334 6.9898 17.1168C4.6898 14.9001 2.05646 11.3084 3.0148 7.07508Z",
    stroke: "#0082CD",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPrimary);
export default __webpack_public_path__ + "static/media/location-primary.b30f814dfcc44004273626f3cb4cd15c.svg";
export { ForwardRef as ReactComponent };